import { cn } from '../../lib/utils';

const toneMap = {
  blue: 'bg-blue-50 text-blue-700 ring-blue-200',
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  amber: 'bg-amber-50 text-amber-700 ring-amber-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
  purple: 'bg-violet-50 text-violet-700 ring-violet-200',
  slate: 'bg-slate-50 text-slate-700 ring-slate-200'
};

export default function StatusChip({ children, tone = 'slate', className }) {
  return (
    <span className={cn(
      'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
      toneMap[tone] || toneMap.slate,
      className
    )}>
      {children}
    </span>
  );
}
